import React from 'react';
import { useTranslation } from 'react-i18next';
import { BOARD_STATUSES } from './ShipmentBoard';

type BoardStatus = (typeof BOARD_STATUSES)[number];

interface ShipmentStatusSwitcherProps {
  activeStatus: BoardStatus;
  onChange: (status: BoardStatus) => void;
}

const ShipmentStatusSwitcher: React.FC<ShipmentStatusSwitcherProps> = ({
  activeStatus,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <div className="shipment-status-switcher" role="tablist" aria-label={t('board_title')}>
      {BOARD_STATUSES.map((status) => (
        <button
          key={status}
          type="button"
          role="tab"
          aria-selected={activeStatus === status}
          className={`shipment-status-switcher-btn${activeStatus === status ? ' active' : ''}`}
          onClick={() => onChange(status)}
        >
          {t(`shipment_status_${status}`)}
        </button>
      ))}
    </div>
  );
};

export default ShipmentStatusSwitcher;
